<template>
  <div id="app">
    <router-view/>
    <Toast></Toast>
    <div class="updateboxbg" v-if="!showLog" @click="closeBox"></div>
    <div class="updatebox" v-if="!showLog" @click="closeBox">
      <div>
        <p>1.【合同管理】增加客姓名搜索条件。</p>
        <p>2.【项目】项目派发设置的要求完成时间以选择日期当天的18点为准。</p>
        <p>3.【项目】项目派发、Work功能bug修复，避免了重复添加。</p>
        <p>4.【项目】项目详情加入动态信息展示。</p>
      </div>
    </div>
  </div>
</template>

<script>
import Toast from "./components/Toast.vue";
export default {
  components: { Toast },
  data() {
    return {
      showLog: true
    };
  },
  name: "App",
  methods: {
    closeBox: function() {
      this.showLog = true;
    }
  },
  async created() {
    this.elementLoding("加载中...");
    this.updateRouter();
    this.elementLodingClose();
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue